<!--
 * @Author: your name
 * @Date: 2021-08-12 14:13:05
 * @LastEditTime: 2021-09-24 09:30:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\components\templates\productDialog.vue
-->
<template>
  <div>
    <el-dialog
      :append-to-body="true"
      title="选择商品"
      width="1000px"
      :visible.sync="productDialogVisible"
      :before-close="CancellHandle"
    >
      <div class="dialog-content">
        <el-form :inline="true" :model="query" ref="query">
          <el-form-item label="商品名称" prop="skuName">
            <el-input v-model="query.skuName" clearable></el-input>
          </el-form-item>
          <el-form-item label="类别名称" prop="categoryName">
            <el-input v-model="query.categoryName" clearable></el-input>
          </el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="getProductList"
            >查询</el-button
          >
          <el-button type="primary" icon="el-icon-delete" @click="handleClear"
            >重置</el-button
          >
        </el-form>

        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
         
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="skuName" label="商品名称" width="150">
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                title="商品名称:"
                width="300"
                trigger="hover"
              >
                <div>{{ scope.row.skuName }}</div>
                <span slot="reference">{{
                  scope.row.skuName.substr(0, 10) + '...' + ''
                }}</span>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="categoryName"
            label="类别名称"
          ></el-table-column>
          <el-table-column prop="price" label="商品价格" align="center">
            <template slot-scope="scope">
              <p>￥{{ scope.row.price > 0 ? scope.row.price : '面议' }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="defaultImage" label="图片预览" align="center">
            <template slot-scope="scope">
              <el-image
                style="width: 50px; height: 50px"
                :src="scope.row.defaultImage"
                :preview-src-list="scope.row.defaultImage.split(',')"
                fit="scale-down"
              ></el-image>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
            :current-page="query.pageNum"
            :page-size="query.pageSize"
            :total="pageTotal"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CancellHandle">取 消</el-button>
        <el-button
          :disabled="multipleSelection.length == 0"
          type="primary"
          @click="submitProduct"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import api from '../../api/product';
export default {
  props: {
    productDialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      userInfo: {},
      tableData: [],
      multipleSelection: [],
      query: {
        supplierCompanyId: '',
        categoryName: '',
        exportStatus: 101,
        pageNum: 1,
        pageSize: 10,
        skuName: '',
      },
      pageTotal: 0,
    };
  },
  created() {
    this.userInfo = this.$store.state.USERINFO;
  },
  watch: {
    productDialogVisible(newV, oldV) {
      console.log(newV, oldV);
      if (newV) {
        this.multipleSelection = [];
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
          this.handleClear();
        });

        this.getProductList();
      }
    },
  },
  methods: {
    submitProduct() {
      // console.log('this.multipleSelection==>',this.multipleSelection)
      // // return
      this.$emit('getProductDialogInfo', this.multipleSelection);
      this.CancellHandle();
    },
    CancellHandle() {
      this.$emit('update:productDialogVisible', false);
    },
    //获取商品列表
    async getProductList() {
      this.query.supplierCompanyId = this.userInfo.companyId;
      let res = await api.querySkuByPage(this.query);
      if (res.code == 200) {
        this.tableData = res.data.records;
        this.pageTotal = res.data.total;
      }
    },
    handleSelectionChange(val) {
      // 单选
    //   if (val.length > 1) {
    //     let arr = [];
    //     let obj = val.pop();
    //     let newArr = arr.push({ ...obj });
    //     this.multipleSelection = newArr;
    //     this.$refs.multipleTable.clearSelection();
    //     this.$refs.multipleTable.toggleRowSelection(obj);
    //   } else {
        this.multipleSelection = val;
   //   }
    },
    // currentChange(currentRow, oldCurrentRow) {
    //   console.log(oldCurrentRow);
    //   this.$refs.multipleTable.toggleRowSelection(currentRow);
    // },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.query.pageNum = 1;
      this.getProductList();
    },
    handleCurrentChange(val) {
      this.query.pageNum = val;
      this.getProductList();
    },
    handleClear() {
      this.$refs.query.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped></style>
